import gql from 'graphql-tag'

export const fetchState = stateId => {
	return {
		query: gql`
			query ($state_id: bigint!) {
				states_by_pk(id: $state_id) {
					name
					country {
						code
					}
					country_area_id
				}
			}
		`,
		update(data) {
			return {
				name: data.states_by_pk.name,
				country_code: data.states_by_pk.country.code,
				country_area_id: data.states_by_pk.country_area_id
			}
		},
		variables: {
			state_id: stateId
		}
	}
}
